import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
// import { useAppParamsContext } from '../../context/AppParamsContext'
import { getPartnerVehicleResult } from '../../helper/partnerSessionStore'
import appUserService from '../../services/appUserService'
import userProductService from '../../services/userProductService'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import HeaderPartner from '../../components/FeaturesComponent/headerPartner'
import BenefitRow from './components/BenefitRow'
import BottomActionBar from './components/BottomActionBar'
import ConfirmDialog from './components/ConfirmDialog'
import NotifyPackageBanner from './components/NotifyPackageBanner'
import benifit1 from '../../assets/images/benifit_1.png'
import benifit2 from '../../assets/images/benifit_2.png'
import benifit3 from '../../assets/images/benifit_3.png'
import benifit4 from '../../assets/images/benifit_4.png'
import benifit5 from '../../assets/images/benifit_5.png'
import benifit6 from '../../assets/images/benifit_6.png'
import benifit7 from '../../assets/images/benifit_7.png'
import benifit8 from '../../assets/images/benifit_8.png'
import benifit9 from '../../assets/images/benifit_9.png'
import benifit10 from '../../assets/images/benifit_10.png'
import benifit11 from '../../assets/images/benifit_11.png'
import trafficFineAutoRenew from '../../assets/images/traffic_fine_auto_renew.png'
// import trafficFineBack from '../../assets/images/traffic_fine_back.png'
import './index.scss'

const BENEFITS = {
  1: 'Thông báo khi có vi phạm',
  2: 'Thông báo khi có vi phạm mới',
  3: 'Thông báo phạt nguội',
  4: 'Thông báo hạn đăng kiểm',
  5: 'Ưu đãi 30% khi mua BH TNDS',
  6: 'Trợ lý tư vấn bảo hiểm',
  7: 'Trợ lý hỗ trợ thủ tục bảo hiểm',
  8: 'Hỗ trợ gói tín dụng chi phí giao thông',
  9: 'Hỗ trợ tặng thẻ tín dụng ưu đãi',
  10: 'Hỗ trợ ưu đãi khi mua gói cứu hộ xe máy',
  11: 'Hỗ trợ ưu đãi khi mua gói cứu hộ ô tô',
  12: 'SMS nhận thông báo tự động hằng tuần',
  13: 'Lịch sử vi phạm và trạng thái xử lý từ Cục Cảnh Sát Giao Thông',
  14: 'Tự động nhắc hạn đăng kiểm (sắp ra mắt)'
}

const BENEFITS_IMAGES = {
  1: benifit1,
  2: benifit2,
  3: benifit3,
  4: benifit4,
  5: benifit5,
  6: benifit6,
  7: benifit7,
  8: benifit8,
  9: benifit9,
  10: benifit10,
  11: benifit11,
  12: benifit1,
  13: benifit2,
  14: benifit3
}

function pickFirst(...vals) {
  for (const v of vals) {
    const s = String(v ?? '').trim()
    if (s) return s
  }
  return ''
}

function parseAllowRenew01(v, fallback = 1) {
  if (v == null) return fallback
  const n = Number(v)
  if (!Number.isFinite(n)) return fallback
  return n === 1 ? 1 : 0
}

export default function TrafficFinePackageInfo() {
  const history = useHistory()
  const location = useLocation()
  // const { isHeaderMiniApp } = useAppParamsContext()
  const session = useMemo(() => getPartnerVehicleResult?.() || null, [])
  const sp = useMemo(() => new URLSearchParams(location.search || ''), [location.search])
  const activePkg = session?.activePkg || null

  const plate = pickFirst(sp.get('plate'), session?.plate, '—')

  const autoRenewUntil = pickFirst(
    sp.get('autoRenewUntil'),
    sp.get('notifyEndDateTime'),
    sp.get('notifyEndDate'),
    activePkg?.notifyEndDateTime,
    activePkg?.notifyEndDate,
    ''
  )

  const productId = Number(sp.get('productId') || activePkg?.productId || 0)

  const productNameFromQuery = pickFirst(sp.get('productName'), activePkg?.productName, 'Gói thông báo')

  const notifyInfoId = pickFirst(sp.get('notifyInfoId'), activePkg?.notifyInfoId, '')

  const vehicleType = Number(sp.get('vehicleType') || session?.vehicleType || 1)

  const allowRenew01 = parseAllowRenew01(sp.get('allowRenew') ?? activePkg?.allowRenew, 1)

  const [autoRenewEnabled, setAutoRenewEnabled] = useState(() => allowRenew01 === 1)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [product, setProduct] = useState(null)
  const [loadingProduct, setLoadingProduct] = useState(false)

  useEffect(() => {
    let alive = true

    async function run() {
      if (!productId) return

      try {
        setLoadingProduct(true)
        const detail = await userProductService.getUserProductDetailService(productId)
        if (!alive) return
        setProduct(detail || null)
      } catch (e) {
        if (alive) setProduct(null)
      } finally {
        if (alive) setLoadingProduct(false)
      }
    }

    run()
    return () => {
      alive = false
    }
  }, [productId])

  const productName = product?.productName || productNameFromQuery

  const benefits = useMemo(() => {
    const productOptionalInfo = product?.productOptionalInfo ? JSON.parse(product?.productOptionalInfo) : {}
    const benefitsList = productOptionalInfo?.benefits || []
    return benefitsList.map((item) => ({
      text: BENEFITS[item],
      iconSrc: BENEFITS_IMAGES[item]
    }))
  }, [product])

  const confirmText = autoRenewEnabled
    ? 'Bạn có chắc chắn muốn Ngừng gia hạn tự động gói thông báo này không?'
    : 'Bạn có chắc chắn muốn Gia hạn tự động gói thông báo này không?'

  const onConfirm = async () => {
    setConfirmOpen(false)
    const nextAllowRenew = autoRenewEnabled ? 0 : 1
    try {
      const res = await appUserService.userUpdateNotifyPackage({
        id: Number(notifyInfoId),
        data: { allowRenew: nextAllowRenew }
      })

      if (!res || res.statusCode !== 200) {
        throw res || new Error('UPDATE_NOTIFY_PACKAGE_FAILED')
      }

      setAutoRenewEnabled(nextAllowRenew === 1)
      const params = new URLSearchParams(sp.toString())
      params.set('allowRenew', String(nextAllowRenew))
      history.replace({
        pathname: location.pathname,
        search: `?${params.toString()}`
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <LayoutPartner>
      <HeaderPartner title={'Quản lý gói thông báo'} />
      <div className="TrafficFinePackageInfo">
        <div className="traffic-fine-package-content" style={{ paddingTop: '20px' }}>
          {/* Legacy header logic (kept for reference)
          {isHeaderMiniApp ? (
            <div className="traffic-fine-package-header">
              <div className="traffic-fine-package-header-row">
                <button
                  type="button"
                  className="traffic-fine-package-header-back"
                  onClick={() => history.goBack()}
                  aria-label="Quay lại">
                  <img src={trafficFineBack} alt="back" />
                </button>
                <div className="traffic-fine-package-header-title">Quản lý gói thông báo</div>
              </div>
            </div>
          ) : (
            <div className="traffic-fine-package-header-space" />
          )}
          */}
          <NotifyPackageBanner
            plate={plate}
            autoRenewUntil={autoRenewUntil}
            productName={productName}
            allowRenew={autoRenewEnabled ? 1 : 0}
            vehicleType={vehicleType}
          />

          <div className="traffic-fine-package-benefits-wrap">
            <div className="traffic-fine-package-benefits-title">Quyền lợi gói đang sở hữu</div>

            <div className="traffic-fine-package-benefits-card">
              {loadingProduct ? (
                <BenefitRow text="Đang tải thông tin gói..." iconSrc={trafficFineAutoRenew} />
              ) : benefits.length ? (
                benefits.map((b) => <BenefitRow key={b.text} text={b.text} iconSrc={b.iconSrc} />)
              ) : (
                <BenefitRow text="Chưa có thông tin quyền lợi." />
              )}
            </div>
          </div>

          <BottomActionBar enabled={autoRenewEnabled} onClick={() => setConfirmOpen(true)} />
        </div>
      </div>
      <ConfirmDialog open={confirmOpen} onClose={() => setConfirmOpen(false)} text={confirmText} onConfirm={onConfirm} confirmLabel="Xác nhận" />
    </LayoutPartner>
  )
}
